module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "plain-box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 small-padding-left"
  }, [_c('div', {
    staticClass: "third-col-box margin-b20"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "height-112 height-72-big padding-18"
  }, [_c('p', {
    staticClass: "no-margin"
  }, [_vm._v("Perfeito para você que gosta de comodidade e não quer se preocupar com recargas ou saldo insuficiente.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/servicos-sodre-plano-conforto"
    }
  }, [_vm._v("Saiba Mais")])], 1), _vm._v(" "), _c('div', {
    staticClass: "height-82 padding-28"
  }, [(_vm.getNewAdhesionTax > 0) ? _c('h3', {
    staticClass: "bold no-margin"
  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.getNewAdhesionTax)))]) : _c('span', [_c('h4', {
    staticClass: "promo-value"
  }, [_vm._v("R$ 39,90")]), _vm._v(" "), _c('b', {
    staticClass: "promo-free"
  }, [_vm._v("Grátis")])])]), _vm._v(" "), _c('div', {
    staticClass: "height-82 padding-28"
  }, [_c('h3', {
    staticClass: "bold no-margin"
  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.getNewVehicleTax)))])]), _vm._v(" "), _c('div', {
    staticClass: "height-82 padding-28"
  }, [_c('h3', {
    staticClass: "bold no-margin"
  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.getReplaceTax)))])]), _vm._v(" "), _c('div', {
    staticClass: "height-82 padding-28"
  }, [_c('h3', {
    staticClass: "bold no-margin"
  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.getMonthlyTax)))])]), _vm._v(" "), _c('div', {
    staticClass: "height-72 padding-t25"
  }, [_c('a', {
    directives: [{
      name: "smooth-scroll",
      rawName: "v-smooth-scroll"
    }],
    staticClass: "make-link",
    attrs: {
      "href": "#rechargeB2C"
    }
  }, [_vm._v("\n                      Veja Nossas Taxas de Recarga\n                    ")])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row-button border-radius-bottom"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "tag": "button"
    },
    on: {
      "click": function($event) {
        return _vm.choose(55)
      }
    }
  }, [_vm._v("\n                      Quero este plano!\n                    ")])])])])])])])])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 first-col-box"
  }, [_c('div', {
    staticClass: "height-72 border-radius-top"
  }, [_c('p', {
    staticClass: "margin-10"
  }, [_c('i', {
    staticClass: "icon-plans icon-plans-table"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "height-112"
  }, [_c('p', {
    staticClass: "bold no-margin padding-t45"
  }, [_vm._v("Como Funciona?")])]), _vm._v(" "), _c('div', {
    staticClass: "height-82"
  }, [_c('p', {
    staticClass: "bold no-margin padding-t35"
  }, [_vm._v("Adesão por Veículo")])]), _vm._v(" "), _c('div', {
    staticClass: "height-82"
  }, [_c('p', {
    staticClass: "bold no-margin padding-12"
  }, [_vm._v("Adesão Veículo Adicional")])]), _vm._v(" "), _c('div', {
    staticClass: "height-82"
  }, [_c('p', {
    staticClass: "bold no-margin padding-12"
  }, [_vm._v("Substituição (TAG)")])]), _vm._v(" "), _c('div', {
    staticClass: "height-82"
  }, [_c('p', {
    staticClass: "bold no-margin padding-12"
  }, [_vm._v("Mensalidade")])]), _vm._v(" "), _c('div', {
    staticClass: "height-72"
  }, [_c('p', {
    staticClass: "bold no-margin padding-23"
  }, [_vm._v("Taxa Recarga (2%)")])]), _vm._v(" "), _c('div', {
    staticClass: "height-82 striped-line"
  }, [_c('p', {
    staticClass: "bold no-margin padding-12"
  }, [_vm._v("Formas de Pagamento")])]), _vm._v(" "), _c('div', {
    staticClass: "height-72 border-radius-bottom",
    staticStyle: {
      "height": "82px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-72 border-radius-top"
  }, [_c('h3', {
    staticClass: "sub-title plan upper no-margin margin-b10"
  }, [_vm._v("Pré-pago Automático sodré "), _c('br'), _vm._v("com mensalidade "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-82 padding-20"
  }, [_c('ul', [_c('li', [_vm._v("Cartão de Crédito")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    attrs: {
      "id": "rechargeB2C"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 margin-b10"
  }, [_c('h3', {
    staticClass: "bold upper"
  }, [_vm._v("Recargas")]), _vm._v(" "), _c('p', [_vm._v("As recargas consistem em taxa fixa de 2%, verifique os valores:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box-recharge"
  }, [_c('div', {
    staticClass: "recharge-red"
  }, [_c('div', {
    staticClass: "recharge-value-red"
  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-label-red"
  }, [_vm._v("50")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-tax-label"
  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v("1,00")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-recharge"
  }, [_c('div', {
    staticClass: "recharge-yellow"
  }, [_c('div', {
    staticClass: "recharge-value-yellow"
  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-label-yellow"
  }, [_vm._v("100")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-tax-label"
  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v("2,00")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-recharge"
  }, [_c('div', {
    staticClass: "recharge-green"
  }, [_c('div', {
    staticClass: "recharge-value-green"
  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-label-green"
  }, [_vm._v("150")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-tax-label"
  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v("3,00")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-recharge"
  }, [_c('div', {
    staticClass: "recharge-blue"
  }, [_c('div', {
    staticClass: "recharge-value-blue"
  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-label-blue"
  }, [_vm._v("200")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-tax-label"
  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v("4,00")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-recharge-last"
  }, [_c('div', {
    staticClass: "recharge-purple"
  }, [_c('div', {
    staticClass: "recharge-value-purple"
  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-label-purple"
  }, [_vm._v("250")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-tax-label"
  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v("5,00")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-recharge"
  }, [_c('div', {
    staticClass: "recharge-red"
  }, [_c('div', {
    staticClass: "recharge-value-red"
  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-label-red"
  }, [_vm._v("300")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-tax-label"
  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v("6,00")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-recharge"
  }, [_c('div', {
    staticClass: "recharge-yellow"
  }, [_c('div', {
    staticClass: "recharge-value-yellow"
  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-label-yellow"
  }, [_vm._v("350")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-tax-label"
  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v("7,00")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-recharge"
  }, [_c('div', {
    staticClass: "recharge-green"
  }, [_c('div', {
    staticClass: "recharge-value-green"
  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-label-green"
  }, [_vm._v("400")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-tax-label"
  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v("8,00")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-recharge"
  }, [_c('div', {
    staticClass: "recharge-blue"
  }, [_c('div', {
    staticClass: "recharge-value-blue"
  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-label-blue"
  }, [_vm._v("450")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-tax-label"
  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v("9,00")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-recharge-last"
  }, [_c('div', {
    staticClass: "recharge-purple"
  }, [_c('div', {
    staticClass: "recharge-value-purple"
  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-label-purple"
  }, [_vm._v("500")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-tax-label"
  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v("10,00")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-37c8cc00!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/external/plans/b2b-sodre.vue
// module id = 2097
// module chunks = 1